module.exports = __webpack_public_path__ + "img/default.46fdddde.png";